import { OPTIONS } from 'app-constants'
import { http } from 'hooks'

export function uploadService() {
  function uploadFile(idContract, file) {
    const formData = new FormData()

    const config = { ...OPTIONS }
    config.headers.mimeType = 'multipart/form-data'

    formData.append('file', file)

    return http.post(`/contract/upload/payment-receipt/${idContract}`, formData, config)
  }
  return {
    uploadFile,
  }
}
